"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var translations = {
    send: {
        en: "Send",
        es: "Enviar",
    },
    save: {
        en: "Save",
        es: "Guardar",
    },
    cancel: {
        en: "Cancel",
        es: "Cancelar",
    },
    close: {
        en: "Close",
        es: "Cerrar",
    },
    next: {
        en: "Next",
        es: "Siguiente",
    },
    previous: {
        en: "Previous",
        es: "Anterior",
    },
    done: {
        en: "Done",
        es: "Listo",
    },
    create: {
        en: "Create",
        es: "Crear",
    },
    download: {
        en: "Download",
        es: "Descargar",
    },
    addAccountTitle: {
        en: "Add User",
        es: "Agregar Usuario",
    },
    editAccountTitle: {
        en: "Edit User",
        es: "Editar Usuario",
    },
    addClientTitle: {
        en: "Add Client",
        es: "Agregar Cliente",
    },
    editClientTitle: {
        en: "Edit Client",
        es: "Editar Cliente",
    },
    clientId: {
        en: "Client ID",
        es: "ID de Cliente",
    },
    addDeviceTitle: {
        en: "Add Device",
        es: "Agregar Unidad",
    },
    editDeviceTitle: {
        en: "Edit Device",
        es: "Editar Unidad",
    },
    editDevicesTitle: {
        en: "Edit Devices",
        es: "Editar Unidades",
    },
    addSimTitle: {
        en: "Add Sim",
        es: "Agregar Sim",
    },
    editSimTitle: {
        en: "Edit Sim",
        es: "Editar Sim",
    },
    addCarrierTitle: {
        en: "Add Carrier",
        es: "Agregar Proveedor",
    },
    editCarrierTitle: {
        en: "Edit Carrier",
        es: "Editar Proveedor",
    },
    editRoleTitle: {
        en: "Edit Roles",
        es: "Editar Roles",
    },
    addCompanyTitle: {
        en: "Add Provider",
        es: "Agregar Proveedor",
    },
    editSessionsTitle: {
        en: "Sessions",
        es: "Sesiones",
    },
    editCompanyTitle: {
        en: "Edit Provider",
        es: "Editar Proveedor",
    },
    impersonateTitle: {
        en: "Impersonate",
        es: "Personificar",
    },
    addGroupTitle: {
        en: "Add Group",
        es: "Agregar Grupo",
    },
    editGroupTitle: {
        en: "Edit Group",
        es: "Editar Grupo",
    },
    sharegroupSubTitle: {
        en: "Let's share some devices with the user to start tracking!",
        es: "Compartamos algunos dispositivos con este usuario para que empiece a rastrear!",
    },
    shareOrCreateGroup: {
        en: "Select an existing group or create a new one",
        es: "Selecciona un grupo existente o crea uno nuevo",
    },
    editModelTitle: {
        en: "Edit Models",
        es: "Editar Modelos",
    },
    addModelTitle: {
        en: "Add Models",
        es: "Agregar Modelos",
    },
    editMaintenanceTitle: {
        en: "Edit Maintenance",
        es: "Editar Mantenimiento",
    },
    addMaintenanceTitle: {
        en: "Add Maintenance",
        es: "Agregar Mantenimiento",
    },
    addEventTitle: {
        en: "Add events",
        es: "Agregar eventos",
    },
    editEventTitle: {
        en: "Edit events",
        es: "Editar eventos",
    },
    addModelProfileTitle: {
        en: "Add Model Profile",
        es: "Agregar Perfil de Modelo",
    },
    editModelProfileTitle: {
        en: "Edit Model Profile",
        es: "Editar Perfil de Modelo",
    },
    ScheduleReports: {
        en: "Scheduled reports",
        es: "Reporte automático",
    },
    sendGrid: {
        en: "SendGrid",
        es: "SendGrid",
    },
    manageLinks: {
        en: "Links Manager",
        es: "Administrador de Links",
    },
    manage: {
        en: "Manage",
        es: "Administrar",
    },
    twilio: {
        en: "Twilio",
        es: "Twilio",
    },
    mailService: {
        en: "Mail service",
        es: "Servicio de correo",
    },
    progressDetail: {
        en: "Progress",
        es: "Progreso",
    },
    sharedDeviceWith: {
        en: "Shared With",
        es: "Compartido Con",
    },
    shareWith: {
        en: "Share with",
        es: "Compartir con",
    },
    shareDevicesWith: {
        en: "Share Group with another user (Optional)",
        es: "Comparte este Grupo con otro usuario (Opcional)",
    },
    resetMaintenance: {
        en: "Reset maintenance",
        es: "Reiniciar mantenimiento",
    },
    clear: {
        en: "Clear",
        es: "Limpiar",
    },
    sendCommandTitle: {
        en: "Send Command",
        es: "Enviar Comando",
    },
    tags: {
        en: "Tag",
        es: "Etiquetar",
    },
    assign: {
        en: "Assign",
        es: "Asignar",
    },
    TagTitle: {
        en: "Tags",
        es: "Etiquetas",
    },
    addPointOfInterest: {
        en: "Add Point Of Interest",
        es: "Agregar Punto de Interés",
    },
    addPointsOfInterest: {
        en: "Add Points Of Interest",
        es: "Agregar Puntos de Interés",
    },
    editPointOfInterest: {
        en: "Edit Point Of Interest",
        es: "Editar Punto de Interés",
    },
    addLinesOfInterest: {
        en: "Add Lines Of Interest",
        es: "Agregar Lineas de Interés",
    },
    editLinesOfInterest: {
        en: "Edit Lines Of Interest",
        es: "Editar Lineas de Interés",
    },
    countryTitle: {
        en: "Countries",
        es: "Países",
    },
    editBranding: {
        en: "Edit Branding",
        es: "Editar Marca",
    },
    addBranding: {
        en: "Add Branding",
        es: "Agregar Marca",
    },
    addScheduleTitle: {
        en: "Add Schedule",
        es: "Agregar Agenda de Ruta",
    },
    editScheduleTitle: {
        en: "Edit Schedule",
        es: "Editar Agenda de Ruta",
    },
    PlacesTitle: {
        en: "Places",
        es: "Geocercas",
    },
    reassigUnits: {
        en: "Reassign units",
        es: "Reasignar unidades",
    },
    moveTo: {
        en: "Move to",
        es: "Mover a",
    },
    addFuelBillTitle: {
        en: "Add Fuel Bill",
        es: "Agregar Factura de Combustible",
    },
    editFuelBillTitle: {
        en: "Edit Fuel Bill",
        es: "Editar Factura de Combustible",
    },
    addGasStationTitle: {
        en: "Add Gas Station",
        es: "Agregar Gasolinera",
    },
    editGasStationTitle: {
        en: "Edit Gas Station",
        es: "Editar Gasolinera",
    },
    addRequesterTitle: {
        en: "Add Requester",
        es: "Agregar Solicitante",
    },
    editRequesterTitle: {
        en: "Edit Requester",
        es: "Editar Solicitante",
    },
    showPoiByTagsTitle: {
        en: "Point of interest tags for map",
        es: "Etiquetas a mostrar en el mapa",
    },
    displacementAlertTitle: {
        en: "Displacement Alert",
        es: "Alerta de Desplazamiento",
    },
    SharePhotoTitle: {
        en: "Share Photo",
        es: "Compartir Foto",
    },
    addCredentialTitle: {
        en: "Add Credential",
        es: "Agregar Credencial",
    },
    editCredentialTitle: {
        en: "Edit Credential",
        es: "Editar Credencial",
    },
    addServiceProviderTitle: {
        en: "Add Service Provider",
        es: "Agregar Proveedor de Servicio",
    },
    editServiceProviderTitle: {
        en: "Edit Service Provider",
        es: "Editar Proveedor de Servicio",
    },
    advancedRoles: {
        en: "Advanced roles",
        es: "Roles avanzados",
    },
    administration: {
        en: "Administration",
        es: "Administración",
    },
    mapView: {
        en: "Map view",
        es: "Vista de mapa",
    },
    sendCommands: {
        en: "Send commands",
        es: "Enviar comandos",
    },
    basicReports: {
        en: "Basic reports",
        es: "Reportes básicos",
    },
    multimediaTitle: {
        en: "Multimedia",
        es: "Multimedia",
    },
    videoCameraConfigurationTitle: {
        en: "Video Camera Configuration",
        es: "Configuración de Camara de Video",
    },
    goBack: {
        en: "Go back",
        es: "Regresar",
    },
    NA: {
        en: "N/A",
        es: "N/D",
    },
    liveVideo: {
        en: "Live Video",
        es: "Video en Vivo",
    },
    liveVideoDescription: {
        en: "Choose a channel to broadcast live footage.",
        es: "Elige un canal para mostrar el video en vivo",
    },
    multimediaDescription: {
        en: "Open an event to display multimedia.",
        es: "Abre un evento para mostrar la multimedia.",
    },
    replaceCardTitle: {
        en: "Replace Card",
        es: "Reemplazar Tarjeta",
    },
    confirmation: {
        en: "Confirmation",
        es: "Confirmación",
    },
};
exports.default = translations;
